import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=42aacbff&scoped=true&"
import script from "./Subscription.vue?vue&type=script&lang=ts&"
export * from "./Subscription.vue?vue&type=script&lang=ts&"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=42aacbff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aacbff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42aacbff')) {
      api.createRecord('42aacbff', component.options)
    } else {
      api.reload('42aacbff', component.options)
    }
    module.hot.accept("./Subscription.vue?vue&type=template&id=42aacbff&scoped=true&", function () {
      api.rerender('42aacbff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Subscription.vue"
export default component.exports